import styled from "styled-components";
import { breakpoints } from "../../globalStyles";

export const AlertFailureBox = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(90deg, #29323c 0%, #485563 100%);
  overflow-y: auto;
`;
export const AlertFailureInner = styled.div`
  padding: 20px 0;
  max-width: 590px;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  @media ${breakpoints.xs} {
    padding: 0 16px;
  }
  @media ${breakpoints.sm} and (orientation: landscape) {
    transform: translateY(15%);
  }
`;
export const AlertImgWrapper = styled.div`
  width: 300px;
  height: 300px;

  @media ${breakpoints.xs} {
    width: 240px;
    height: 240px;
  }
`;
export const AlertImg = styled.img`
  display: block;
  height: auto;
  max-width: 100%;
`;

export const AlertTitle = styled.h2`
  margin-top: 16px;
  font-family: "Inter";
  font-weight: 900;
  font-size: var(--xl-font-size);
  line-height: 120%;
  color: #fff;
  text-align: center;

  @media ${breakpoints.lg} {
    letter-spacing: 1px;
  }
`;

export const AlertDesc = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: var(--md-font-size);
  line-height: 140%;
  color: rgba(255, 255, 255, 0.9);
  text-align: center;
`;
